import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core/';
import React from 'react';
import {
  useGetList,
  required,
  SelectInput,
  TextInput,
  RadioButtonGroupInput,
  useQuery,
  Loading,
  maxLength
} from 'react-admin';

// Styling overrides
const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  }
});

const DisplayForm = props => {
  const classes = useStyles();

  const fundIds = props.fundinvestors.map(item => item.fundId);

  const { data: fundsChoices = [], loading } = useGetList('funds', null, null, {
    id: `[${fundIds}]`
  });
  if (loading) return <Loading />;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5" className={classes.headerContainer}>
          General Details
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <RadioButtonGroupInput
          source="preferredFlag"
          label="Transfer Method"
          options={{ row: true }}
          margin="none"
          choices={[
            { id: 0, name: 'Wire Transfer' },
            { id: 1, name: 'Check' }
          ]}
          variant="standard"
          helperText={false}
          defaultValue={0}
        />
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          allowEmpty
          label="Use for"
          source="fundId"
          resource="funds"
          reference="funds"
          helperText={false}
          variant="standard"
          validate={[required()]}
          choices={Object.values(fundsChoices)}
          emptyText="All Funds"
          emptyValue="*"
          initialValue="*"
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="wireDescription"
          label="Description"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5">Beneficiary Details</Typography>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryAccount"
          label="Account Number"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="reference"
          label="Reference"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryName"
          label="Name"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryAddress1"
          label="Address 1"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryAddress2"
          label="Address 2"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryCity"
          label="City"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryPostalCode"
          label="Zip/Postal Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryState"
          label="Country/State"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="attentionTo"
          label="Attention To"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={3} />
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5">Beneficiary Bank Details</Typography>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankSwift"
          label="SWIFT Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankAbaRoutingCode"
          label="ABA/Routing Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryIban"
          label="IBAN"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankName"
          label="Bank Name"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankAddress1"
          label="Address 1"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankAddress2"
          label="Address 2"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankPostalCode"
          label="Zip/Postal Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankCity"
          label="City"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="beneficiaryBankState"
          label="Country/State"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={3} />
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5">
          Intermediary/Receiving Bank Details
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankSwift"
          label="SWIFT Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankAbaRoutingCode"
          label="ABA/Routing Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankName"
          label="Bank Name"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankAddress1"
          label="Address 1"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankAddress2"
          label="Address 2"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankPostalCode"
          label="Zip/Postal Code"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankCity"
          label="City"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="receivingBankState"
          label="Country/State"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={12} className={classes.headerContainer}>
        <Typography variant="h5">Further Credit &amp; Notes</Typography>
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="furtherCreditToAccountNumber"
          label="Further Credit To Account Number"
          variant="standard"
          helperText={false}
          validate={maxLength(30)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="furtherCreditToName"
          label="Further Credit To Name"
          variant="standard"
          helperText={false}
          validate={maxLength(255)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextInput
          source="notes"
          label="Notes"
          variant="standard"
          helperText={false}
          validate={maxLength(1000)}
        />
      </Grid>
      <Grid item xs={3} />
    </Grid>
  );
};

const WireInstructionSummary = props => {
  const { data = [], loading } = useQuery({
    type: 'getManyReference',
    resource: 'fundinvestors',
    payload: {
      target: 'investorId',
      id: props.investorId,
      sort: {
        order: 'ASC'
      }
    }
  });
  if (loading) return <Loading />;
  return <DisplayForm fundinvestors={data} />;
};

export default WireInstructionSummary;
